<template>
  <b-modal
    centered
    size="md"
    :visible="show"
    hide-footer
    hide-header
    no-close-on-backdrop
    no-close-on-esc
  >
    <div class="modern-modal-content">
      <!-- Header -->
      <div class="modern-modal-header">
        <div class="modern-modal-icon-wrapper">
          <v-icon name="file-download" scale="1.5"></v-icon>
        </div>
        <h3 class="modern-modal-title">{{ $t("globals.orders_export") }}</h3>
        <p class="modern-modal-description">{{ $t('globals.select_date_range_to_export') }}</p>
      </div>

      <!-- Date Picker -->
      <div class="modern-modal-form-section">
        <label class="modern-modal-label">{{ $t('globals.date_range') }}</label>
        <ulu-date-picker
          range
          v-model="dateRange"
          lang="en"
          format="DD.MM.YYYY"
          :placeholder="$t('globals.select_range')"
          class="modern-modal-date-picker"
        />
      </div>

      <!-- Actions -->
      <div class="modern-modal-actions">
        <b-btn
          @click="close()"
          class="modern-modal-btn modern-modal-btn-cancel"
        >
          <v-icon name="times" scale="0.9"></v-icon>
          {{ $t("globals.cancel") }}
        </b-btn>
        <b-btn
          @click="downloadCsv"
          :disabled="dateRange == null"
          class="modern-modal-btn modern-modal-btn-success"
        >
          <v-icon name="download" scale="0.9"></v-icon>
          {{ $t("globals.download") }}
        </b-btn>
      </div>
    </div>
    <a
      href=""
      id="csvdownloadlink"
      ref="csvfiledownload"
      hidden="true"
      download=""
    ></a>
  </b-modal>
</template>

<script>
import axios from "axios";
import { mapGetters, mapMutations } from "vuex";

import "vue-awesome/icons/file-download";
import "vue-awesome/icons/download";
import "vue-awesome/icons/times";

export default {
  components: {
    "ulu-date-picker": () => import("vue2-datepicker"),
    "v-icon": () => import("vue-awesome/components/Icon.vue")
  },
  props: {
    show: Boolean,
    close: Function
  },
  data() {
    return {
      dateRange: null
    };
  },
  methods: {
    ...mapMutations(["setShowLoadingModal"]),
    downloadCsv() {
      this.setShowLoadingModal(true);

      let from = this.dateRange[0];
      let to = this.dateRange[1];

      from = `${from.getFullYear()}.${from.getMonth() + 1}.${from.getDate()}`;
      to = `${to.getFullYear()}.${to.getMonth() + 1}.${to.getDate()}`;

      let data = {
        query: `query {
          ordersCsv (
            date_from: "${from}",
            date_to: "${to}"
          )
        }`
      };

      axios
        .post(this.getGraphQlUrl, data, this.getDefConf)
        .then(res => {
          if (res.data.errors !== undefined && res.data.errors.length > 0) {
            alert(res.data.errors[0].message);
            console.log(res.data.errors);
          } else {
            this.startDownloadCSV(res.data.data.ordersCsv);
          }
        })
        .catch(err => {
          alert(err);
        })
        .then(() => {
          this.setShowLoadingModal(false);
        });
    },
    startDownloadCSV(csv) {
      let d = new Date();
      let d_string = `${d.getUTCFullYear()}-`;
      d_string += `${("0" + (d.getUTCMonth() + 1)).slice(-2)}-`;
      d_string += `${("0" + d.getUTCDate()).slice(-2)}`;

      let from = this.dateRange[0];
      let to = this.dateRange[1];

      from = `${from.getFullYear()}.${from.getMonth() + 1}.${from.getDate()}`;
      to = `${to.getFullYear()}.${to.getMonth() + 1}.${to.getDate()}`;

      let link = document.getElementById("csvdownloadlink");
      link.href = "data:Application/octet-stream," + encodeURIComponent(csv);
      link.style.display = "block";
      link.download = `Orders_${this.getUserSystem}_export_range_${from}-${to}_on_${d_string}.csv`;
      link.click();
    }
  },
  computed: {
    ...mapGetters(["getDefConf", "getGraphQlUrl", "getUserSystem"])
  }
};
</script>

<style scoped>
@import '../../../styles/modal.css';
</style>
